import {TakipSorguAlanlari} from "@/components/pickers/TakipSorguAlanlariPicker.vue";
import {TakipSorguAlanlani} from "@/plugins/uyap-plugin/store/modules/TaskDataInterface/TakipSorgulaTaskDataInterface";
import {SenkronPlanAlan} from "@/services/senkronPlanService";
import {ASGARI_FREKANS, AZAMI_FREKANS} from "@/services/senkronPlanGovde";

/**
 * Alan + frekans matrisinin saf mantığı (Faz 3, DEV-2966).
 *
 * ALAN LİSTESİ KOPYALANMAZ. Kaynak, picker'ın kendi dışa açık dizisidir
 * (`TakipSorguAlanlariPicker.vue` içindeki `export const TakipSorguAlanlari`).
 * Sunucudaki beyaz liste (`App\Enums\Sorgu\TakipSorguAlanlari`) bu kümenin
 * kopyasıdır ve backend testi ikisinin aynı kalmasını kilitliyor; istemcide
 * üçüncü bir kopya tutmak o zinciri sessizce kırardı. Picker'ın KENDİSİ
 * değiştirilmez — yalnız verisi okunur.
 */

/** Picker'ın 30 alanı, picker sırasında. */
export const TUM_ALANLAR: Array<TakipSorguAlanlani> = TakipSorguAlanlari;

/** Ekranda satır başına tutulan durum. */
export interface AlanSatiri {
    name: string;
    label: string;
    ucretli: boolean;
    secili: boolean;
    frekansGun: number;
}

/** Yeni seçilen alanın varsayılan frekansı: her gece. */
export const VARSAYILAN_FREKANS = 1;

export function frekansGecerliMi(frekans: any): boolean {
    const sayi = Number(frekans);
    return Number.isInteger(sayi) && sayi >= ASGARI_FREKANS && sayi <= AZAMI_FREKANS;
}

/** `[{name, frekans_gun}]` -> `{name: frekans_gun}`. */
export function alanlariMapeCevir(alanlar: Array<SenkronPlanAlan>): Record<string, number> {
    const harita: Record<string, number> = {};
    (alanlar ?? []).forEach((alan) => {
        harita[alan.name] = Number(alan.frekans_gun);
    });
    return harita;
}

/**
 * Plandaki alanları ekran satırlarına açar (picker sırasında, 30 satır).
 * Planda olmayan alanlar seçilmemiş, varsayılan frekanslı gelir.
 */
export function alanSatirlariniKur(alanlar: Array<SenkronPlanAlan>): Array<AlanSatiri> {
    const harita = alanlariMapeCevir(alanlar);
    return TUM_ALANLAR.map((alan) => ({
        name: alan.name,
        label: alan.label,
        ucretli: alan.type === "ucretliSorgu",
        secili: Object.prototype.hasOwnProperty.call(harita, alan.name),
        frekansGun: harita[alan.name] ?? VARSAYILAN_FREKANS
    }));
}

/**
 * Ekran satırlarını plan alanlarına geri çevirir — MEVCUT SIRAYI KORUYARAK.
 *
 * Sıra korunmasaydı: sunucu `alanlar` JSON'unu kanonikleştirirken LİSTELERDE
 * sırayı anlamlı sayıyor (alan sırası görevin `data.sorguAlanlari` sırasına
 * birebir yansıyor). Kullanıcı düzenleme dialogunu açıp hiçbir şey değiştirmeden
 * kaydettiğinde, satırlar picker sırasına dizilseydi içerik "değişti" görünür,
 * sunucu gecenin paketini iptal edip yeniden üretir ve kullanıcının görev
 * listesinde sahte bir iptal paketi belirirdi.
 *
 * Bu yüzden: önce plandaki sırayla hâlâ seçili olanlar (güncel frekanslarıyla),
 * sonra yeni seçilenler picker sırasında eklenir.
 */
export function alanSatirlariniPlanaCevir(
    satirlar: Array<AlanSatiri>,
    mevcutAlanlar: Array<SenkronPlanAlan>
): Array<SenkronPlanAlan> {
    const satirHaritasi: Record<string, AlanSatiri> = {};
    satirlar.forEach((satir) => {
        satirHaritasi[satir.name] = satir;
    });

    const sonuc: Array<SenkronPlanAlan> = [];
    const yazilan: Record<string, boolean> = {};

    (mevcutAlanlar ?? []).forEach((alan) => {
        const satir = satirHaritasi[alan.name];
        if (!satir || !satir.secili || yazilan[alan.name]) return;
        sonuc.push({name: alan.name, frekans_gun: Number(satir.frekansGun)});
        yazilan[alan.name] = true;
    });

    satirlar.forEach((satir) => {
        if (!satir.secili || yazilan[satir.name]) return;
        sonuc.push({name: satir.name, frekans_gun: Number(satir.frekansGun)});
        yazilan[satir.name] = true;
    });

    return sonuc;
}

/** Seçili ücretli alan var mı — form "ücretli sorguya devam" anahtarını buna göre gösterir. */
export function seciliUcretliVarMi(satirlar: Array<AlanSatiri>): boolean {
    return satirlar.some((satir) => satir.secili && satir.ucretli);
}
